import { render, staticRenderFns } from "./NeetTareaDocenteMenu.vue?vue&type=template&id=724e69c4&scoped=true"
import script from "./NeetTareaDocenteMenu.vue?vue&type=script&lang=js"
export * from "./NeetTareaDocenteMenu.vue?vue&type=script&lang=js"
import style0 from "./NeetTareaDocenteMenu.vue?vue&type=style&index=0&id=724e69c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e69c4",
  null
  
)

export default component.exports